// extracted by mini-css-extract-plugin
export default {"App":"App_App__B2Ebb","AppWrapper":"App_AppWrapper__cbyq5","links":"App_links__cHL6L","text":"App_text__iRJvH"};